<template>
    <section class="parameter">
        <div class="title">商品参数 <span>PARAMETER</span></div>
        <div class="parameterItem">
            <table>
                <tr><td>品牌名称:VIVOY85</td><td>运营商:全网通</td></tr>
                <tr><td>运行内存:3G/4G</td><td>机身内存:32G/64G</td></tr>
                                <tr><td>品牌名称:VIVOY85</td><td>运营商:全网通</td></tr>
                <tr><td>运行内存:3G/4G</td><td>机身内存:32G/64G</td></tr>
                                <tr><td>品牌名称:VIVOY85</td><td>运营商:全网通</td></tr>
                <tr><td>运行内存:3G/4G</td><td>机身内存:32G/64G</td></tr>
                                <tr><td>品牌名称:VIVOY85</td><td>运营商:全网通</td></tr>
                <tr><td>运行内存:3G/4G</td><td>机身内存:32G/64G</td></tr>
                                <tr><td>品牌名称:VIVOY85</td><td>运营商:全网通</td></tr>
                <tr><td>运行内存:3G/4G</td><td>机身内存:32G/64G</td></tr>
            </table>
        </div>
    </section>
</template>

<script>
export default {

}
</script>

<style scoped>
.title{border-bottom:solid #efefef 1px;padding: 10px 0;font-size: 20px;color: #f9415d}
.title::before{content: "";display: inline-block;width: 12px;height: 12px;border:solid #f9415d 2px;margin-right: 10px;rotate: 10px;transform:rotate(45deg)}
.title span{color: #ccc;}
table{width: 100%;margin:20px 0;}
table tr{background: #f5f5f5;}
table tr:nth-child(2n){background: #fff;}
table tr td{width: 50%;padding:10px;}

</style>
